export function applyFavicon(url) {
  if (!url) return;

  const href = url.includes("?") ? url : `${url}?v=${Date.now()}`;

  const setLink = (rel) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
  };

  setLink("icon");
  setLink("shortcut icon");

  let apple = document.querySelector('link[rel="apple-touch-icon"]');
  if (!apple) {
    apple = document.createElement("link");
    apple.rel = "apple-touch-icon";
    document.head.appendChild(apple);
  }
  apple.href = href;
}
